import sanitizeHtml from "sanitize-html";

interface HtmlProps {
  html: string;
  className?: string;
}

export const Html = (props: HtmlProps) => {
  const cleanHtml = sanitizeHtml(props.html);
  // biome-ignore lint/security/noDangerouslySetInnerHtml: html is sanitized
  return <div className={props.className} dangerouslySetInnerHTML={{ __html: cleanHtml }} />;
};
